import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid } from "@material-ui/data-grid";
import { Button, Modal, Form, Row, Col, InputGroup } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import PlacesAutoComplete from "../../../components/AddressAutoComplete";
import * as Admin from "../../../store/ducks/admin.duck";
import { Grid, Paper } from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function CsCentres() {
  const [searchTerm, setSearchTerm] = useState("");
  const csCentres = useSelector((state) => state.admin.CsCentres);
  const filteredCsCentres = csCentres.filter((csCentre) => csCentre.centerName.toLowerCase().search(searchTerm.toLowerCase()) > -1 || searchTerm.length === 0);
  const role = useSelector((state) => state.auth.roleDesc);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Admin.actions.fetchCsCentres());
  }, [dispatch]);

  var [show, setShow] = useState(false);
  var [currentID, setCurrentID] = useState();
  var [currentCenterName, setCurrentCenterName] = useState();
  var [currentEmail, setCurrentEmail] = useState();
  var [currentPhone, setCurrentPhone] = useState();
  var [currentFax, setCurrentFax] = useState();
  var [currentContact, setCurrentContact] = useState();
  var [currentContactEmail, setCurrentContactEmail] = useState();
  var [currentContactPhone, setCurrentContactPhone] = useState();
  var [currentFullAddress, setCurrentFullAddress] = useState();
  var [currentPostCode, setCurrentPostCode] = useState();
  var [currentLongitude, setCurrentLongitude] = useState();
  var [currentLatitude, setCurrentLatitude] = useState();
  var [currentWebsite, setCurrentWebsite] = useState();
  var [currentPracticeType, setCurrentPracticeType] = useState();
  var [currentmmmCode, setCurrentmmmCode] = useState();
  var [currentEligibility1, setCurrentEligibility1] = useState();
  var [currentEligibility2, setCurrentEligibility2] = useState();
  var [currentEligibility3, setCurrentEligibility3] = useState();
  var [currentEligibilitySpecial, setCurrentEligibilitySpecial] = useState();
  var [currentPathWaysLink, setCurrentDocumentLink] = useState();
  var [currentNewPathwaysDocument, setCurrentNewPathwaysDocument] = useState();
  var [currentDefaultReminderEmail, setCurrentDefaultReminderEmail] = useState();

  const loadCsCentreDetail = (thisCsCentre) => {
    setCurrentID(thisCsCentre.id);
    setCurrentCenterName(thisCsCentre.centerName);
    setCurrentEmail(thisCsCentre.email);
    setCurrentPhone(thisCsCentre.phone);
    setCurrentFax(thisCsCentre.fax);
    setCurrentContact(thisCsCentre.contact);
    setCurrentContactEmail(thisCsCentre.contactEmail);
    setCurrentContactPhone(thisCsCentre.contactPhone);
    setCurrentFullAddress(thisCsCentre.fullAddress);
    setCurrentPostCode(thisCsCentre.postCode);
    setCurrentLongitude(thisCsCentre.longitude);
    setCurrentLatitude(thisCsCentre.latitude);
    setCurrentWebsite(thisCsCentre.website);
    setCurrentPracticeType(thisCsCentre.practiceType);
    setCurrentmmmCode(thisCsCentre.mmmCode);
    setCurrentEligibility1(thisCsCentre.eligibility1);
    setCurrentEligibility2(thisCsCentre.eligibility2);
    setCurrentEligibility3(thisCsCentre.eligibility3);
    setCurrentEligibilitySpecial(thisCsCentre.eligibilitySpecial);
    setCurrentDocumentLink(thisCsCentre.documentLink);
    setCurrentDefaultReminderEmail(thisCsCentre.defaultReminderEmail);
    setCurrentNewPathwaysDocument(null);
    setShow(true);
  };

  const createNewCsCentre = () => {
    setCurrentID(0);
    setCurrentCenterName();
    setCurrentEmail();
    setCurrentPhone();
    setCurrentFax();
    setCurrentContact();
    setCurrentContactEmail();
    setCurrentContactPhone();
    setCurrentFullAddress();
    setCurrentPostCode();
    setCurrentLongitude();
    setCurrentLatitude();
    setCurrentWebsite();
    setCurrentPracticeType();
    setCurrentmmmCode();
    setCurrentEligibility1("No");
    setCurrentEligibility2("No");
    setCurrentEligibility3("No");
    setCurrentEligibilitySpecial("No");
    setCurrentDefaultReminderEmail();
    setCurrentNewPathwaysDocument(null);
    setShow(true);
  };

  function putCsCentre() {
    // Move from useState to FormData
    const formData = new FormData();
    //
    // Add fields
    formData.append("id", currentID);
    formData.append("centerName", currentCenterName);
    formData.append("email", currentEmail);
    formData.append("phone", currentPhone);
    formData.append("fax", currentFax);
    formData.append("contact", currentContact);
    formData.append("contactEmail", currentContactEmail);
    formData.append("contactPhone", currentContactPhone);
    formData.append("fullAddress", currentFullAddress);
    formData.append("postCode", currentPostCode);
    formData.append("longitude", currentLongitude);
    formData.append("latitude", currentLatitude);
    formData.append("website", currentWebsite);
    formData.append("practiceType", currentPracticeType);
    formData.append("mmmCode", currentmmmCode);
    formData.append("eligibility1", currentEligibility1);
    formData.append("eligibility2", currentEligibility2);
    formData.append("eligibility3", currentEligibility3);
    formData.append("eligibilitySpecial", currentEligibilitySpecial);
    formData.append("newPathwaysDocument", currentNewPathwaysDocument);
    formData.append("defaultReminderEmail", currentDefaultReminderEmail);
    //
    process.env.REACT_APP_DEBUG && console.log(...formData);
    process.env.REACT_APP_DEBUG && console.log("Saving data");
    // Save update
    dispatch(Admin.actions.putCsCentre({ formData }));
    setShow(false);
  }

  function PathwaysDownload(props) {
    // Check to see if link is populated
    if (!props.documentLink) {
      return null;
    }
    //
    return (
      <Button variant="info" size="sm" href={props.documentLink}>
        <DescriptionIcon fontSize="small" style={{ marginRight: 6, marginTop: -1 }} /> Download
      </Button>
    );
  }

  function handleFileFieldChangeNewPathwaysDocument(propertyName, event) {
    setCurrentNewPathwaysDocument(event.currentTarget.files[0]);
  }

  const columns = [
    { field: "id", headerName: "ID", width: 100, hide: true },
    {
      field: "centerName",
      headerName: "Center Name",
      width: 200,
      renderCell: (params) => (
        <strong>
          <div onClick={() => loadCsCentreDetail(csCentres.find((csCentre) => csCentre.id === params.row.id))} className="cell-Link">
            {params.value}
          </div>
        </strong>
      ),
    },
    { field: "mmmCode", headerName: "MMM Code", width: 200 },
    { field: "fullAddress", headerName: "Address", width: 500 },
    { field: "contact", headerName: "Contact", width: 200 },
    { field: "email", headerName: "Email", width: 200 },
  ];

  function handleClose() {
    setShow(false);
  }

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
  };

  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <h4 style={{ marginBottom: 12 }}>Centralised Service Centre Maintenance</h4>
        </Grid>
      </Grid>

      <Paper>
        <Grid container justifyContent="space-between" style={{ padding: 10 }}>
          <Grid item style={{ marginTop: 2, marginLeft: 10 }}>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control type="text" value={searchTerm} onChange={(event) => handleSearch(event)} autoComplete="OFF" />
            </InputGroup>
          </Grid>
          <Grid item style={{ marginLeft: 20, marginRight: 10 }}>
            <Button variant="primary" size="sm" onClick={() => createNewCsCentre()}>
              Create Centre
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {csCentres ? (
        <Paper style={{ height: 700 }}>
          <DataGrid rows={filteredCsCentres} columns={columns} pageSize={10} checkboxSelection={false} rowHeight={40} />
        </Paper>
      ) : (
        "None"
      )}

      <Modal show={show} onHide={handleClose} dialogClassName="contracts-modal">
        <Modal.Header closeButton className="contracts-modal">
          <Modal.Title>Centre Maintenance </Modal.Title>
        </Modal.Header>
        <Modal.Body className="contracts-modal">
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Centre Name</Form.Label>
                <Form.Control
                  type="text"
                  name="CenterName"
                  defaultValue={currentCenterName}
                  onBlur={(event) => setCurrentCenterName(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="8">
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>Centre Address</Form.Label>
                <PlacesAutoComplete
                  currentID={currentID}
                  currentfulladdress={currentFullAddress}
                  setcurrentfulladdress={setCurrentFullAddress}
                  setcurrentLatitude={setCurrentLatitude}
                  setcurrentLongitude={setCurrentLongitude}
                  setcurrentPostCode={setCurrentPostCode}
                />
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group>
                <Form.Label>Reporting Postcode</Form.Label>
                <Form.Control
                  type="text"
                  name="Postcode"
                  defaultValue={currentPostCode}
                  onBlur={(event) => setCurrentPostCode(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Centre Admin Email</Form.Label>
                <Form.Control
                  type="text"
                  name="Email"
                  defaultValue={currentEmail}
                  onBlur={(event) => setCurrentEmail(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="Phone"
                  defaultValue={currentPhone}
                  onBlur={(event) => setCurrentPhone(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group>
                <Form.Label>Fax</Form.Label>
                <Form.Control
                  type="text"
                  name="Fax"
                  defaultValue={currentFax}
                  onBlur={(event) => setCurrentFax(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Website</Form.Label>
                <Form.Control
                  type="text"
                  name="Website"
                  defaultValue={currentWebsite}
                  onBlur={(event) => setCurrentWebsite(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group className="mb-0" style={{ width: "100%" }}>
                <Form.Label>Default Email for Centre Reminders</Form.Label>
                <Form.Control
                  type="text"
                  name="DefaultReminderEmail"
                  defaultValue={currentDefaultReminderEmail}
                  onBlur={(event) => setCurrentDefaultReminderEmail(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
            {/* <Col md="6">
              <Form.Group className="mb-0" style={{ width: "100%", marginTop: "25px" }}>
                <Form.Label style={{ fontStyle: "italic", color: "blue"}}>If default is entered, all centre related booking remidners will be sent to this address rather than the Client Centre Contact.</Form.Label>
              </Form.Group>
            </Col>  */}
          </Row>
          <Row>
            <Form.Label style={{ marginLeft: 10, fontWeight: "bold" }}>Centre Manager Contact Information</Form.Label>
          </Row>
          <Row>
            <Col md="5">
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="Contact"
                  defaultValue={currentContact}
                  onBlur={(event) => setCurrentContact(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  name="ContactEmail"
                  defaultValue={currentContactEmail}
                  onBlur={(event) => setCurrentContactEmail(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="ContactPhone"
                  defaultValue={currentContactPhone}
                  onBlur={(event) => setCurrentContactPhone(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Form.Label style={{ marginLeft: 10, fontWeight: "bold" }}>Eligibility Information</Form.Label>
          </Row>
          <Row>
            <Col md="8">
              <Form.Group>
                <Form.Label> MMM Code *</Form.Label>
                <Form.Control as="select" defaultValue={currentmmmCode} onBlur={(event) => setCurrentmmmCode(event.target.value)} disabled={role !== "Admin"}>
                  <option value="MMM1 (Metropolitan)">MMM1 (Metropolitan)</option>
                  <option value="MMM2 (Regional centre)">MMM2 (Regional centre)</option>
                  <option value="MMM3 (Large rural town)">MMM3 (Large rural town)</option>
                  <option value="MMM4 (Medium rural town)">MMM4 (Medium rural town)</option>
                  <option value="MMM5 (Small rural town)">MMM5 (Small rural town)</option>
                  <option value="MMM6 (Remote communities)">MMM6 (Remote communities)</option>
                  <option value="MMM7 (Very remote communities)">MMM7 (Very remote communities)</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="8">
              <Form.Group>
                <Form.Label> Priority 1: Centre operating for less than 12 months? *</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={currentEligibility1}
                  onBlur={(event) => setCurrentEligibility1(event.target.value)}
                  disabled={role !== "Admin"}
                >
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="8">
              <Form.Group>
                <Form.Label> Priority 2: MMM Code 3-7 *</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={currentEligibility2}
                  onBlur={(event) => setCurrentEligibility2(event.target.value)}
                  disabled={role !== "Admin"}
                >
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="8">
              <Form.Group>
                <Form.Label> Priority 3: Satellite Centre *</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={currentEligibility3}
                  onBlur={(event) => setCurrentEligibility3(event.target.value)}
                  disabled={role !== "Admin"}
                >
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="8">
              <Form.Group>
                <Form.Label> Special exemption granted *</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={currentEligibilitySpecial}
                  onBlur={(event) => setCurrentEligibilitySpecial(event.target.value)}
                  disabled={role !== "Admin"}
                >
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Centres Emergency Pathways Document:</Form.Label>
                <div style={{ width: "100%" }}>
                  <PathwaysDownload documentLink={currentPathWaysLink} />
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Upload New:</Form.Label>
                <Form.Control
                  type="file"
                  name="NewPathwaysDocument"
                  onChange={(event) => handleFileFieldChangeNewPathwaysDocument("newPathwaysDocument", event)}
                  className="form-control"
                  style={{ paddingTop: 6, paddingLeft: 6 }}
                />
                -
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="contracts-modal">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={putCsCentre}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
